import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useConfigStore = create(
  persist(
    (set) => ({
      gApi: null,
      setGApi: (key) => set({ gApi: key }),
    }),
    {
      name: 'config-storage',
    }
  )
);

export default useConfigStore;
